import React, { useState } from 'react'
import isMobile from 'ismobilejs'
import { Container, Image, Carousel, Css } from '@pdrj/pmi-iqos-ds-react'
import {
  Video,
  LazyImage,
  constants,
  thumbnailBackground
} from '@pdrj/pmi-iqos-shared-react'

const MediaContainer = ({ mediaFullHeight, children }) => {
  return (
    <Container
      display={Container.displays.flex}
      alignItems={Container.alignItemsValues.center}
      justifyContent={Container.justifyContentValues.center}
      fullWidth
      fullHeight={mediaFullHeight}
      height={mediaFullHeight ? 'auto' : ['80', '128']}
      p="5">
      {children}
    </Container>
  )
}

const ProductCarousel = ({
  media = [],
  mediaFullHeight,
  children,
  productThumbnailBg,
  optionThumbnailBg
}) => {
  const showArrows = !isMobile().any
  const [currentSlide, setCurrentSlide] = useState(0)
  const [playingIndex, setPlayingIndex] = useState(null)
  const [fullScreen, setFullScreen] = useState(false)

  const pauseAllVideos = () => {
    const allVideos = document.querySelectorAll('video')
    allVideos.forEach(v => v.pause())
  }

  const handleChangeImageClick = index => {
    pauseAllVideos()
    setPlayingIndex(index)
    setCurrentSlide(index)
  }

  return media.length > 0 ? (
    <>
      <Container fullWidth position={Container.positions.relative}>
        <Css
          s={{
            backgroundColor: thumbnailBackground(
              productThumbnailBg,
              optionThumbnailBg
            )
          }}>
          {children ? (
            <Container
              position={Container.positions.absolute}
              t="0"
              l="0"
              r="0"
              b="0"
              fullHeight>
              {children}
            </Container>
          ) : null}
          <Container fullWidth additionalClasses={'q-min-h-80 md:q-min-h-128'}>
            <Carousel
              showArrows={showArrows}
              showFullScreen
              data-testing-prefix="ProductDetail"
              showIndicators
              getItemInfo={index => media[index] && media[index].alt}
              hasThumbnails
              currentSlideIndex={currentSlide}
              setCurrentSlideIndex={i => handleChangeImageClick(i)}
              setIsFullScreen={setFullScreen}>
              {media.map((item, i) => (
                <MediaContainer key={i} mediaFullHeight={mediaFullHeight}>
                  {item.type === 'image' ? (
                    <Image src={item.path} alt={item.alt} />
                  ) : (
                    <Video
                      shouldPlay={i === playingIndex && !fullScreen}
                      item={item}
                    />
                  )}
                </MediaContainer>
              ))}
            </Carousel>
          </Container>
        </Css>
      </Container>
      <Container
        fullWidth
        display={Container.displays.flex}
        justifyContent={Container.justifyContentValues.center}
        alignItems={Container.alignItemsValues.center}
        pt="4">
        {media.map((item, index) => (
          <Container
            key={index}
            rounded={Container.roundedSizes.lg}
            additionalClasses={`q-mx-1 ${
              currentSlide === index ? 'q-border' : ''
            }`}
            onClickHandler={() => handleChangeImageClick(index)}>
            <Container
              bg={Container.backgrounds.secondary}
              opacity={currentSlide === index ? '0' : '75'}
              width="12"
              height="12"
              position={Container.positions.absolute}
            />
            {item.type === 'video' && (
              <Container
                width="12"
                height="12"
                display={Container.displays.flex}
                position={Container.positions.absolute}
                justifyContent={Container.justifyContentValues.center}
                alignItems={Container.alignItemsValues.center}>
                <Image
                  width="5"
                  height="5"
                  src={`${constants.IMAGE_BASE_URL}/icons8-circled-play-100.png`}
                />
              </Container>
            )}

            <Image width="12" height="12" cover src={item.thumbnail} />
          </Container>
        ))}
      </Container>
    </>
  ) : (
    <MediaContainer>
      <LazyImage />
    </MediaContainer>
  )
}

export default ProductCarousel
